module.exports = {
  NODE_ENV: '"production"',
  API_ROOT: 'https://mangalgril.ru',
  FRONT_URL: 'http://mangalgril.ru'
}



// WEBPACK FOOTER //
// ./config/prod.env.js